import axios from "axios";
import API_BASE_URL from '../../config';

export const SetFavoriteUserService = async (token, userId, taskId) => {
  try {
    if (!token) {
      throw new Error("No token available");
    }

    const response = await axios.post(`${API_BASE_URL}api/set-favorites-user/`, 
      {
        user_id: userId,
        task_id: taskId
      }, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error al agregar favorito:', error.response ? error.response.data : error.message);
    throw error;
  }
};
